<template>
    <div class="hszd-card" >
        <div class="hszd-card-head">
            {{ title }}
        </div>
        <div class="hszd-card-body" ref="cardRef">
            <slot />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
defineProps({
    title: {
        type: String,
    }
})
const emit = defineEmits(['resize'])
const cardRef = ref(null);
const resizeObserver = new ResizeObserver(() => {
    // 处理大小变化的逻辑
    const rect = cardRef.value.getBoundingClientRect()
    emit('resize', { width: rect.width, height: rect.height - 80 })
});
onMounted(() => {
    if (cardRef.value) {
        resizeObserver.observe(cardRef.value);
    }
});

onBeforeUnmount(() => {
    resizeObserver.disconnect();
});
</script>

<style scoped>
.hszd-card {
    height: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 13px 0px rgba(61,122,227,0.2);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.hszd-card-head {
    padding: 0 14px;
    border-bottom: 1px solid #ECF1F7;
    line-height: 50px;
    font-size: 16px;
    color: #222222;
    font-weight: 800;
}
.hszd-card-body {
    padding: 24px;
    flex: 1;
    height: 0;
    overflow: auto;
}
</style>